export default {
  name: 'transaction_customer_address_city',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_options: {
    autocomplete: 'shipping address-level2'
  }
}